import type { Prize } from '@/types/prizes'

import { isPrizeOpenEnrollment } from './prizeRuleMessage'

import type { PrizeUiStatus } from '../constants/status'

type PrizeStatusContext = {
  isParticipating: boolean
  isWinner: boolean
}

export const getPrizeUiStatus = (
  prize: Prize,
  { isParticipating, isWinner }: PrizeStatusContext
): PrizeUiStatus => {
  if (prize.executed) {
    return isWinner ? 'success' : 'expired'
  }

  if (isParticipating) return 'progress'

  if (isPrizeOpenEnrollment(prize.prize_rules)) return 'available'

  return 'locked'
}

type PrizeWinnerRow = {
  id?: number
  user?: { id?: number; name?: string } | null
}

/**
 * Ganhadores já anunciados de um concurso.
 *
 * O payload público só desce quem foi anunciado — quem está apenas selado viaja
 * escondido de propósito, para a revelação no palco não ser estragada.
 */
export const resolvePrizeWinners = (prize: Prize): PrizeWinnerRow[] => {
  const winners = (prize as { winners?: PrizeWinnerRow[] }).winners

  return Array.isArray(winners) ? winners : []
}

/** Compara como texto: o identificador chega como número do payload e como
 *  texto da sessão em parte dos provedores. */
export const isPrizeWinner = (prize: Prize, userId?: string | number | null) => {
  if (userId == null) return false

  const normalized = String(userId)

  return resolvePrizeWinners(prize).some(
    winner => winner.user?.id != null && String(winner.user.id) === normalized
  )
}
